module.exports = __webpack_public_path__ + "static/feature_5-9ebcba8dd435b3f01898a40b7dbf4e71.svg";